/**
 * Script relative to job ad show template
 */


const loadGoogleMapsApi = require('load-google-maps-api')

let map,
  apiKey = document.querySelector('#maps-values').dataset.apiKey,
  mapScriptOptions = {
    'key': apiKey
  },
  lat = parseFloat(document.querySelector('#maps-values').dataset.supplierLat),
  lng = parseFloat(document.querySelector('#maps-values').dataset.supplierLng),
  pinIcon = document.querySelector('#maps-values').dataset.pinIcon

// Lance l'init de la map
loadGoogleMapsApi(mapScriptOptions)
  .then(googleMaps => {
    initMap(googleMaps)
  })

// Initialise la map centrée sur le distributeur, avec un marqueur
function initMap (googleMaps) {
  map = new googleMaps.Map(document.getElementById('map'), {
    center: {lat: lat, lng: lng},
    zoom: 14,
  })

  new googleMaps.Marker({
    position: {lat: lat, lng: lng},
    map: map,
    icon: pinIcon
  })
}
